export default __webpack_public_path__ + "static/media/notFoundBgMb.e4ee0e7f.png";